/**
 * Copyright ©2022 Drivepoint
 */

import "./init_globals"; // must be imported first to define window and global properties
import React from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import quarterOfYear from "dayjs/plugin/quarterOfYear";
import relativeTime from "dayjs/plugin/relativeTime";
import utc from "dayjs/plugin/utc";
import weekday from "dayjs/plugin/weekday";
import ModalProvider from "mui-modal-provider";
import {createRoot} from "react-dom/client";
import {BrowserRouter} from "react-router-dom";
import DazzlerDataManager from "@services/DazzlerDataManager";
import ErrorCodes from "@services/ErrorCodes";
import App from "./main/App/App";
import Licenses from "./main/Licenses";
import LaunchDarklyClient from "./services/clients/LaunchDarklyClient";
import DynamicImportService from "./services/DynamicImportService";
import Firebase from "./services/firebase/Firebase";
import GoogleCharts from "./services/google/GoogleCharts";
import ServiceRegistry from "./services/ServiceRegistry";
import Telemetry from "./services/telemetry/Telemetry";
import "./index.css";
// import "./branding/test-company.css";

(async () => {

  dayjs.extend(quarterOfYear);
  dayjs.extend(weekday);
  dayjs.extend(relativeTime);
  dayjs.extend(advancedFormat);
  dayjs.extend(utc);

  await ErrorCodes.init();
  await DazzlerDataManager.init();
  await DynamicImportService.init();
  Licenses.init();
  await LaunchDarklyClient.init();
  await Telemetry.init();
  await Firebase.init();
  await ServiceRegistry.init();
  await GoogleCharts.init();

  createRoot(document.getElementById("root")!).render(<BrowserRouter><ModalProvider><App /></ModalProvider></BrowserRouter>);

})();
